import type { ReportData } from '@weft/types';
import { filterBy } from '@weft/utils';
import { values } from 'lodash';
import { getReportJobType } from '../../pages/reports/reports-page/reports-page-components/ReportsPageContent';
import type { ReportType } from '../../pages/reports/reports-page/reports-page-types/report-type';
import { REPORT_TYPES } from '../../pages/reports/reports-page/reports-page-types/report-type';
import { useReports } from './use-reports';

export type ReportSummary = {
  title: ReportType;
  count: number;
};

export function useReportSummaries() {
  const { data: reportsData } = useReports({ suspense: true });

  return values(REPORT_TYPES).map((reportType) => buildReportSummary(reportType, reportsData));
}

const singleReportTypes: ReportType[] = [
  REPORT_TYPES.AR_AGING,
];

function getReportCount(reportType: ReportType, reportsData: ReportData[]) {
  if (singleReportTypes.includes(reportType)) {
    return 1;
  }

  if (reportType === REPORT_TYPES.ALL_REPORTS) {
    return Object.keys(REPORT_TYPES).length - 1;
  }
  
  const reportJobType = getReportJobType(reportType);

  return reportJobType ? filterBy(reportsData, reportJobType, 'type').length : 0;
}

const buildReportSummary = (reportType: ReportType, reportsData: ReportData[]): ReportSummary => ({
  title: reportType,
  count: getReportCount(reportType, reportsData),
});